import React from 'react'

import clsx from 'clsx'

import Avatar from 'components/Avatar'
import Icon from 'components/Icon'
import Typography from 'components/Typography'
import { formatAvatarInitials } from 'helpers/formatters'
import fullStory from 'helpers/fullStoryCssClasses'

import classes from './Header.module.scss'

/** @type {import('./types').default} */
const Header = ({ isLoggedIn, name, pictureUrl }) => {
  return (
    <div
      className={clsx('Header', classes.root, { isLoggedIn, [fullStory.MASK]: isLoggedIn })}
      data-testid="user_drawer-header"
    >
      {isLoggedIn ? (
        <div className={classes.texts}>
          <Typography className={classes.welcomeBackText} variant="tight-xxs">
            Welcome back,
          </Typography>
          <Typography className={classes.nameText} variant="heading-md">
            {name}
          </Typography>
        </div>
      ) : (
        <Typography variant="heading-md">Hello!</Typography>
      )}
      <Avatar
        className={clsx(classes.userAvatar, fullStory.EXCLUDE)}
        src={isLoggedIn ? pictureUrl : undefined}
        variant="rounded"
      >
        {isLoggedIn ? formatAvatarInitials(name) : <Icon className={classes.userIcon} icon="user" />}
      </Avatar>
    </div>
  )
}

export default Header
